
<div class="row">
  <div class="col-md-4 offset-md-4 d-flex justify-content-center">
    <h1>Register</h1>
  </div> 
</div>


<div>
  <div class="row">
    <div class="col-md-4 offset-md-4 border shadow p-3 mb-5 rounded-lg">
        <form  [formGroup]="registerForm" (ngSubmit)="register()" >
          
          <div class="form-group">
            <mat-form-field>
              <mat-label>Email</mat-label> 
              <input matInput [formControl]="f.email" [errorStateMatcher]="matcher"
                    placeholder="Ex. pat@example.com">
              <mat-error *ngIf="f.email.hasError('email') && !f.email.hasError('required')">
                Please enter a valid email address
              </mat-error>
              <mat-error *ngIf="f.email.hasError('required')">
                Email is <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field>
              <mat-label>Password</mat-label> 
              <input matInput type="password" [formControl]="f.password" [errorStateMatcher]="matcher"
                    placeholder="Password">
              <mat-error *ngIf="f.password.hasError('minlength')">
                Minimum 6 caracters
              </mat-error>
              <mat-error *ngIf="f.password.hasError('required')">
                Password <strong>required</strong>
              </mat-error>
            </mat-form-field>
          </div>


          <div class="form-group">
            <mat-form-field>
              <mat-label>Password confirm</mat-label> 
              <input matInput type="password" [formControl]="f.passwordConfirm" [errorStateMatcher]="matcher"
                    placeholder="password Confirm">
              <mat-error *ngIf="f.passwordConfirm.hasError('mustMatch')">
                Passwords must match
              </mat-error>
            </mat-form-field>
          </div>
          <re-captcha (resolved)="resolved($event)" siteKey="6Lc6NPwUAAAAAIJB4hh8ps4u3Xg8vgjELEsIXg7Y"></re-captcha>
          <div *ngIf="errorCapcha">Please fill the captcha</div>
          <div *ngIf="error">{{ errorMessage }}</div>
          <div class="text-right">
            <button mat-raised-button type="submit" color="accent" class="m-2">Submit</button>
            <mat-spinner diameter="30" *ngIf='loading'></mat-spinner>
          </div>


        </form>
      </div>
  </div>
</div>